import { supabase } from './supabase'

/**
 * Returns a PostgREST query builder scoped to the given tenant schema.
 * Uses supabase.schema() which sets Accept-Profile/Content-Profile headers.
 *
 * All existing RLS policies are enforced natively by PostgREST.
 *
 * Tenant schemas are created dynamically and their tables are not included
 * in the auto-generated Supabase types. We use a loose return type so
 * .from() accepts any tenant table name. Individual hooks cast results
 * to the correct TypeScript interfaces from @/types/tenant.
 *
 * @example
 * const { data } = await tenantQuery('tenant_procimo')
 *   .from('locations')
 *   .select('*')
 *   .order('name')
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function tenantQuery(schemaName: string): any {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return supabase.schema(schemaName as any)
}
